<template>
  <div class="d-flex flex-column align-center pt-12">
    <h1 class="headline align-self-center">Search for a test</h1>

    <v-card width="1000" class="mt-5">
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="items"
          :sort-by="['interviewDate']"
          :sort-desc="[true]"
        >
          <template v-slot:item.interviewDate="{ item }">{{
            convertDateWithHour(item.interviewDate)
          }}</template>
          <template v-slot:item.actions="{ item }">
            <v-icon style="cursor: pointer" @click="edit(item)"
              >mdi-pencil</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="cellexDialog" width="400">
      <v-card>
        <v-card-text class="d-flex flex-column">
          <div class="subtitle-1 font-weight-bold mb-2">
            1. {{ $t("cellexTest.first.firstTitle") }}
          </div>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.firstNameLabel') + '*'"
            v-model="editingItem.firstName"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.lastNameLabel') + '*'"
            v-model="editingItem.lastName"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.idNumberLabel') + '*'"
            v-model="editingItem.formJsonText.personalInfo.idNumber"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.orgCode') + '*'"
            v-model="editingItem.orgCode"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.emailLabel') + '*'"
            v-model="editingItem.email"
          ></v-text-field>

          <v-radio-group
            v-model="editingItem.formJsonText.personalInfo.gender"
            column
            dense
            :label="$t('cellexTest.first.genderLabel')"
            class="align-self-start"
          >
            <v-radio
              :label="$t('cellexTest.first.male')"
              value="male"
              color="primary"
              :ripple="false"
            ></v-radio>
            <v-radio
              :label="$t('cellexTest.first.female')"
              value="female"
              color="primary"
              :ripple="false"
            ></v-radio>
          </v-radio-group>

          {{editingItem.formJsonText.personalInfo.birthDate}}

          <v-menu
            ref="menu"
            v-model="editingItem.menu"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="editingItem.formJsonText.personalInfo.birthDate.substr(0,10)"
                :label="$t('cellexTest.first.birthDateLabel')"
                prepend-icon="mdi-calendar"
                class="flex-grow-0"
                v-on="on"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="editingItem.formJsonText.personalInfo.birthDate"
              no-title
              color="primary"
            ></v-date-picker>
          </v-menu>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.countryLabel')"
            v-model="editingItem.formJsonText.personalInfo.country"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.nationalityLabel')"
            v-model="editingItem.formJsonText.personalInfo.nationality"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.cityLabel')"
            v-model="editingItem.formJsonText.personalInfo.city"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.addressLabel')"
            v-model="editingItem.formJsonText.personalInfo.address"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.postalCodeLabel')"
            v-model="editingItem.formJsonText.personalInfo.postalCode"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.first.phoneLabel')"
            v-model="editingItem.formJsonText.personalInfo.phone"
          ></v-text-field>

          <p>{{ $t("cellexTest.third.thirdSubtitle") }}</p>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.coughLabel')"
            v-model="editingItem.formJsonText.questionnaire.cough"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.breathlessnessLabel')"
            v-model="editingItem.formJsonText.questionnaire.breathlessness"
          ></v-checkbox>

          <p>{{ $t("cellexTest.third.thirdSubtitle2") }}</p>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.feverLabel')"
            v-model="editingItem.formJsonText.questionnaire.fever"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.coldsLabel')"
            v-model="editingItem.formJsonText.questionnaire.colds"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.shiverLabel')"
            v-model="editingItem.formJsonText.questionnaire.shiver"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.muscularPainLabel')"
            v-model="editingItem.formJsonText.questionnaire.muscularPain"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.headacheLabel')"
            v-model="editingItem.formJsonText.questionnaire.headache"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.soreThroatLabel')"
            v-model="editingItem.formJsonText.questionnaire.soreThroat"
          ></v-checkbox>
          <v-checkbox
            class="pa-0 ma-0"
            :label="$t('cellexTest.third.noTasteLabel')"
            v-model="editingItem.formJsonText.questionnaire.noTaste"
          ></v-checkbox>
          <v-divider></v-divider>
          <v-checkbox
            :label="$t('cellexTest.third.liveInQuarantinedPlaceLabel')"
            v-model="
              editingItem.formJsonText.questionnaire.liveInQuarantinedPlace
            "
          ></v-checkbox>
          <v-divider></v-divider>
          <v-checkbox
            :label="$t('cellexTest.third.familyHasCovidLabel')"
            v-model="editingItem.formJsonText.questionnaire.familyHasCovid"
          ></v-checkbox>
          <v-divider></v-divider>
          <v-checkbox
            :label="$t('cellexTest.third.lastTwentyOneDaysLabel')"
            v-model="editingItem.formJsonText.questionnaire.lastTwentyOneDays"
          ></v-checkbox>
          <v-divider></v-divider>
          <v-checkbox
            :label="$t('cellexTest.third.goneHospitalLabel')"
            v-model="editingItem.formJsonText.questionnaire.goneHospital"
          ></v-checkbox>
          <v-divider></v-divider>
          <v-checkbox
            :label="$t('cellexTest.third.diseasesLabel')"
            v-model="editingItem.formJsonText.questionnaire.diseases"
          ></v-checkbox>

          <v-radio-group
            v-model="editingItem.formJsonText.results.isPositive"
            column
            dense
            :label="$t('cellexTest.fourth.resultsLabel')"
            class="align-self-start"
          >
            <v-radio
              :label="$t('cellexTest.fourth.positive')"
              value="positive"
              color="primary"
              :ripple="false"
            ></v-radio>
            <v-radio
              :label="$t('cellexTest.fourth.negative')"
              value="negative"
              color="primary"
              :ripple="false"
            ></v-radio>
            <v-radio
              :label="$t('cellexTest.fourth.unsure')"
              value="unsure"
              color="primary"
              :ripple="false"
            ></v-radio>
          </v-radio-group>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.fourth.temperatureLabel')"
            v-model="editingItem.formJsonText.results.temperature"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            :label="$t('cellexTest.fourth.serialNumberLabel')"
            v-model="editingItem.formJsonText.results.serialNumber"
          ></v-text-field>


      <v-radio-group label="Τύπος test" v-model="editingItem.formJsonText.results.testType">
        <v-radio value="pcr" label="Pcr"></v-radio>
        <v-radio value="rapid" label="Rapid"></v-radio>
                <v-radio value="antigon" label="Αντιγόνου"></v-radio>
      </v-radio-group>

          <v-btn @click="submitEdit">Αποθήκευση</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  created() {
    this.getAll();
  },

  data() {
    return {
      loading: false,
      headers: [
        {
          text: "id",
          value: "testId",
        },
        {
          text: "First name",
          value: "firstName",
        },
        {
          text: "Lastname",
          value: "lastName",
        },
        {
          text: "Test date",
          value: "interviewDate",
        },
        {
          text: "Company",
          value: "orgCode",
        },
        {
          text: "actions",
          value: "actions",
        },
      ],
      items: [],
      editingItem: {
        testId: null,
        caseCode: null,
        orgCode: null,
        interviewDate: null,
        resultDate: null,
        lastname: null,
        firstName: null,
        passportNo: null,
        email: null,
        reportType: "cellex",
        formJsonText: {
          personalInfo: {},
          questionnaire: {},
          results: {},
        },
        result: null,
      },
      cellexDialog: false,
    };
  },

  methods: {
    getAll() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/case/`)
        .then((res) => {
          this.loading = false;
          res.data.forEach(datum => {
           // console.log(datum.formJsonText)
            if(Object.keys(datum.formJsonText).length == 0){
          //    console.log('hjihi')
              datum.formJsonText = {
                personalInfo: {},
                questionnaire: {},
                results: {}
              }
            }
          });
        //  console.log(res.data)
          this.items = res.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    convertDateWithHour(date) {
      return moment(new Date(date)).local().format("DD/MM/YYYY");
      // return new Date(date)

      //return new Date(date)
    },
    edit(item) {
      if (item.reportType == "tourist") {
        this.$store.dispatch("setEditingTouristTest", item);
      } else if (item.reportType == "shipping") {
        this.$store.dispatch("setEditingShippingTest", item);
      } else if (item.reportType == "cellex") {
        this.editingItem = { ...item };
        this.cellexDialog = true;
      }
    },

    submitEdit(){
      axios.put(`${process.env.VUE_APP_BASE_URL}/case/${this.editingItem.testId}`, this.editingItem)
      .then(res => {
        console.log('edit res',res)
        this.cellexDialog = false
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
};
</script>